// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container-component {
  opacity: 0;
  visibility: hidden;
  height: 100vh;
  width: 100vw;
  transition: 0.3s ease-in-out;
  position: fixed;
  background-color: rgba(255, 255, 255, 0.85);
  top: 0;
  left: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}
.modal-container-component.visible {
  opacity: 1;
  visibility: visible;
}
.modal-container-component .modal-container {
  font-family: "Proxima Nova", sans-serif;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);
  border-radius: 25px;
  width: 660px;
  overflow: hidden;
}
.modal-container-component .modal-container .modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  position: relative;
  background-color: var(--secondary-color-4);
  border-bottom: 1px solid #BEBEBE;
}
.modal-container-component .modal-container .modal-header .modal-title {
  display: flex;
  justify-content: center;
  font-weight: 700;
  font-size: 20px;
  width: 100%;
  color: var(--secondary-color-1);
  position: relative;
}
.modal-container-component .modal-container .modal-header .modal-title .close {
  position: absolute;
  right: 25px;
  cursor: pointer;
}
.modal-container-component .modal-container .modal-body {
  padding: 20px 30px;
  max-height: 70vh;
  overflow-y: auto;
}
.modal-container-component .modal-container .modal-body .user-container > p {
  font-size: 13px;
  font-weight: 700;
}
.modal-container-component .modal-container .modal-body .user-container .user-info {
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.modal-container-component .modal-container .modal-body .user-container .user-info > div {
  display: flex;
}
.modal-container-component .modal-container .modal-body .user-container .user-info > div img {
  width: 55px;
  height: 55px;
  object-fit: cover;
  border: 3px solid white;
  border-radius: 10px;
  margin-right: 15px;
}
.modal-container-component .modal-container .modal-body .user-container .user-info > div > div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.modal-container-component .modal-container .modal-body .user-container .user-info > div > div > p {
  margin: 0;
  font-size: 14px;
  color: var(--secondary-color-1);
  font-weight: 700;
}
.modal-container-component .modal-container .modal-body .user-container .user-info > div > div > span {
  font-size: 12px;
  color: var(--secondary-color-5);
}
.modal-container-component .modal-container .modal-body .user-container .user-info .phone-number {
  font-size: 12px;
  color: var(--secondary-color-5);
}`, "",{"version":3,"sources":["webpack://./src/components/ModalContainer/modalContainer.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,2CAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACJ;AAAI;EACI,UAAA;EACA,mBAAA;AAER;AAAI;EACI,uCAAA;EACA,mBAAA;EACA,kDAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,gCAAA;AAGZ;AAFY;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;AAIhB;AAHgB;EACI,kBAAA;EACA,WAAA;EACA,eAAA;AAKpB;AADQ;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AAGZ;AADgB;EACI,eAAA;EACA,gBAAA;AAGpB;AADgB;EACI,eAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;AAGpB;AAFoB;EACI,aAAA;AAIxB;AAHwB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAK5B;AAHwB;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAK5B;AAJ4B;EACI,SAAA;EACA,eAAA;EACA,+BAAA;EACA,gBAAA;AAMhC;AAJ4B;EACI,eAAA;EACA,+BAAA;AAMhC;AAFoB;EACI,eAAA;EACA,+BAAA;AAIxB","sourcesContent":[".modal-container-component {\n    opacity: 0;\n    visibility: hidden;\n    height: 100vh;\n    width: 100vw;\n    transition: .3s ease-in-out;\n    position: fixed;\n    background-color: rgba($color: white, $alpha: .85);\n    top: 0;\n    left: 0;\n    z-index: 999999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 20px;\n    &.visible {\n        opacity: 1;\n        visibility: visible;\n    }\n    .modal-container {\n        font-family: 'Proxima Nova', sans-serif;\n        background: #FFFFFF;\n        box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);\n        border-radius: 25px;\n        width: 660px;\n        overflow: hidden;\n        .modal-header {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            height: 60px;\n            position: relative;\n            background-color: var(--secondary-color-4);\n            border-bottom: 1px solid #BEBEBE;\n            .modal-title {\n                display: flex;\n                justify-content: center;\n                font-weight: 700;\n                font-size: 20px;\n                width: 100%;\n                color: var(--secondary-color-1);\n                position: relative;\n                .close {\n                    position: absolute;\n                    right: 25px;\n                    cursor: pointer;\n                }\n            }\n        }\n        .modal-body {\n            padding: 20px 30px;\n            max-height: 70vh;\n            overflow-y: auto;\n            .user-container {\n                > p {\n                    font-size: 13px;\n                    font-weight: 700;\n                }\n                .user-info {\n                    padding: 15px 0;\n                    display: flex;\n                    justify-content: space-between;\n                    width: 100%;\n                    > div {\n                        display: flex;\n                        img {\n                            width: 55px;\n                            height: 55px;\n                            object-fit: cover;\n                            border: 3px solid white;\n                            border-radius: 10px;\n                            margin-right: 15px;\n                        }\n                        > div {\n                            display: flex;\n                            flex-direction: column;\n                            justify-content: center;\n                            > p {\n                                margin: 0;\n                                font-size: 14px;\n                                color: var(--secondary-color-1);\n                                font-weight: 700;\n                            }\n                            > span {\n                                font-size: 12px;\n                                color: var(--secondary-color-5);\n                            }\n                        }\n                    }\n                    .phone-number {\n                        font-size: 12px;\n                        color: var(--secondary-color-5);\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
